import { render, staticRenderFns } from "./issuable_list_root.vue?vue&type=template&id=0622e7d4&"
import script from "./issuable_list_root.vue?vue&type=script&lang=js&"
export * from "./issuable_list_root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports